module.exports = __webpack_public_path__ + "static/media/exactValueTriangle1.bc2f5592.svg";